import { z } from "zod";
import { codeSchema } from "@features/account/model";

export const codesResponseSchema = z.array(codeSchema);

export type CodesResponseType = z.infer<typeof codesResponseSchema>;
